export const LOCALES = ['en', 'ru']
export const PROJECT_ID = 'd742963f-905b-11eb-bc85-42010aa80004'
export const GAME_DEV_URL = '//dev.ranchitgame.com/index_xsolla.html'
export const GAME_RELEASE_URL = '//cdn.ranchitgame.com/webgl/index_xsolla.html'
export const XLURLS = {
  recover: {
    url: 'https://login.xsolla.com/api/password/reset/request',
    method: 'post',
    result: null
  },
  resend: {
    url: 'https://login.xsolla.com/api/user/resend_confirmation_link',
    method: 'post',
    result: null
  },
  reset: {
    url: 'https://login.xsolla.com/api/password/reset/confirm',
    method: 'post',
    result: null
  },
  signin: {
    url: 'https://login.xsolla.com/api/login',
    method: 'post',
    result: ['login_url']
  },
  signup: {
    url: 'https://login.xsolla.com/api/user',
    method: 'post',
    result: ['login_url']
  },
  social_google: {
    url: 'https://login.xsolla.com/api/social/google/login_url',
    method: 'get',
    result: ['url']
  },
  social_facebook: {
    url: 'https://login.xsolla.com/api/social/facebook/login_url',
    method: 'get',
    result: ['url']
  },
  social_vk: {
    url: 'https://login.xsolla.com/api/social/vk/login_url',
    method: 'get',
    result: ['url']
  },
  social_ok: {
    url: 'https://login.xsolla.com/api/social/ok/login_url',
    method: 'get',
    result: ['url']
  }
}
